document.addEventListener('DOMContentLoaded', ()=> {
	const dataContainer = document.querySelector('[data-tier-prices-list]');

	const variantNotAvailableText = dataContainer.dataset.notAvailableText;

	const currentLang = dataContainer.dataset.locale;
	const currentSku = document.querySelector('[data-sku]').dataset.sku;
	const priceNoVariantContainer = document.querySelector('.price__no-variant');
	const noVariantText = priceNoVariantContainer.dataset.noVariantText;

	function findVariantTierList(tierPricesList, variantSku){
		const product = tierPricesList.find(item => item.sku === variantSku);
		return product ? product.tierPrice : null;
	}

	const variantsTierPriceLists = JSON.parse(dataContainer.dataset.tierPricesList);
	const currentVariantTierList = findVariantTierList(variantsTierPriceLists, currentSku);

	// VAT

	const param = window.sessionStorage.getItem('pricing');

	////

	const price = document.querySelector('.price__current');
	let productPrice = JSON.parse(dataContainer.dataset.unitPrice)/100;

	const vatValue = Number(dataContainer.dataset.vatValue);

	let vatPrice = +productPrice * vatValue;
	const tierListContainer = document.querySelector('[data-tier-price-container]');

	const unitPrice = param ? vatPrice : productPrice;

	const totalPriceContainer = document.querySelector('#total-price');
	const compareAtPriceContainer = document.querySelector('#total-price-was');

	price.innerText = param? `€${replaceWithComma(unitPrice.toFixed(2))} IVA inclusa` : `€${replaceWithComma(unitPrice.toFixed(2))} IVA esclusa`;

	let quantitySelected = 1;
	if (tierListContainer) tierListContainer.innerText = '';

	const compareAtPriceValue = compareAtPriceContainer && compareAtPriceContainer.dataset.comparePrice ? JSON.parse(compareAtPriceContainer.dataset.comparePrice)/100: '';

	function replaceWithComma (value) {
		return value.toString().replace('.', ',');
	}

	function findDiscount (tierList, quantity) {
		if (!tierList) return;
		return tierList
						.sort((a, b)=> b.quantity - a.quantity)
						.find(tier => quantity >= tier.quantity)
						?.discount;
	}

	function resolveTierValues(tierValues) {
		if(!tierValues) return;
		return tierValues.map((disc) => {
			const [quantity, discount] = disc.split('#').map(Number)
				return {
					quantity,
					discount
				}
		})
	}

	function findVariantTierList(tierPricesList, variantSku){
		const product = tierPricesList.find(item => item.sku === variantSku);
		return product? product.tierPrice : null;
	}

	function createTierList (list, currentVariantPrice) {

		for(key in list) {
			const quantity = list[key].quantity;
			const discount = list[key].discount;
			const line = document.createElement("p");
			line.style.marginBottom = '2px';
			const originalPrice = (currentVariantPrice - currentVariantPrice * discount / 100) * quantity;
			// TODO: ADD TRANSLATION FOR STRING
			if(currentLang === 'Italiano'){
				line.innerHTML = `Prezzo per ${quantity} confezioni: <span class="tier-price">€${replaceWithComma((Math.ceil(originalPrice * 100) / 100).toFixed(2))} ${param ? "IVA inclusa": "IVA esclusa"}</span>`;
			} else if(currentLang === 'English'){
				line.innerHTML = `Price for ${quantity} items: <span class="tier-price">€${replaceWithComma((Math.ceil(originalPrice * 100) / 100).toFixed(2))}</span>`;
			}
			tierListContainer.appendChild(line);
		}
	}

	const resolvedDiscountList = resolveTierValues(currentVariantTierList);

	createTierList(resolvedDiscountList, unitPrice);

	document.addEventListener('on:product:change-quantity', (event) => {
		quantitySelected = event.detail.quantity;


		const currentSku = document.querySelector('[data-sku]').dataset.sku;
		const currentVariantTierList = findVariantTierList(variantsTierPriceLists, currentSku);

		const discount = findDiscount(resolveTierValues(currentVariantTierList), +quantitySelected)

		compareAtPriceContainer.innerText = compareAtPriceValue > 0 ? `€${replaceWithComma((compareAtPriceValue * quantitySelected).toFixed(2))} ${param ? "IVA inclusa": "IVA esclusa"}`: '';

		if(discount) {
			let discountedPrice = productPrice - productPrice * discount/100;
			price.innerText =`€${replaceWithComma((productPrice - productPrice * discount/100).toFixed(2))} ${param ? "IVA inclusa": "IVA esclusa"}`;
			totalPriceContainer.innerText = `€${replaceWithComma((Math.ceil((discountedPrice * quantitySelected)*100)/100).toFixed(2))} ${param ? "IVA inclusa": "IVA esclusa"}`;
		} else {
			price.innerText = `€${replaceWithComma(productPrice.toFixed(2))} ${param ? "IVA inclusa": "IVA esclusa"}`;
			totalPriceContainer.innerText = `€${replaceWithComma((Math.ceil((productPrice * quantitySelected)*100)/100).toFixed(2))} ${param ? "IVA inclusa": "IVA esclusa"}`;
		}
	});

	document.addEventListener('on:variant:change', (event)=>{

		const currentSku = document.querySelector('[data-sku]').dataset.sku;
		const currentVariantTierList = findVariantTierList(variantsTierPriceLists, currentSku);
		tierListContainer.classList.toggle('fade-tier-prices', !event.detail.variant);
		
		if (!event.detail.variant) {
			priceNoVariantContainer.innerText = noVariantText;
			totalPriceContainer.innerHTML = variantNotAvailableText;
			return;
		}

		productPrice = param ? event.detail.variant.price/100 * 1.22 : event.detail.variant.price/100;
		tierListContainer.innerText = '';

		createTierList(resolveTierValues(findVariantTierList(variantsTierPriceLists, currentSku)), productPrice);

		const discount = findDiscount(resolveTierValues(currentVariantTierList), +quantitySelected)
		
		if(discount) {
			let discountedPrice = productPrice - productPrice * discount/100;
			price.innerText =`€${replaceWithComma((productPrice - productPrice * discount/100).toFixed(2))} ${param ? "IVA inclusa": "IVA esclusa"}`;
			totalPriceContainer.innerText = `€${replaceWithComma((Math.ceil((discountedPrice * quantitySelected)*100)/100).toFixed(2))} ${param ? "IVA inclusa": "IVA esclusa"}`;
		} else {
			price.innerText = `€${replaceWithComma((productPrice).toFixed(2))} ${param ? "IVA inclusa": "IVA esclusa"}`;
			totalPriceContainer.innerText = `€${replaceWithComma((Math.ceil((productPrice * quantitySelected)*100)/100).toFixed(2))} ${param ? "IVA inclusa": "IVA esclusa"}`;
		}
	})

	// TOTAL PRICE MANAGEMENT
	if(param){
		compareAtPriceContainer.innerText = compareAtPriceValue > 0 ? `€${replaceWithComma(compareAtPriceValue)}`: '';
		totalPriceContainer.innerText = `€${replaceWithComma(unitPrice.toFixed(2))} IVA inclusa`;
	} else {
		compareAtPriceContainer.innerText = compareAtPriceValue > 0 ? `€${replaceWithComma(compareAtPriceValue)}`: '';
		totalPriceContainer.innerText = `€${replaceWithComma(productPrice.toFixed(2))} IVA esclusa`;
	}
		
});